import * as React from 'react';
import { get, isArray, keys } from 'lodash';
import { reduxForm } from 'redux-form';
import { withRouter } from 'react-router-dom';
import { Grid, Row, Col } from 'react-flexbox-grid';
import { compose, withPropsOnChange, withProps } from 'recompose';
import { Tabs, Tab, Card } from 'material-ui';

import Button from '@inqool/uas-web-core/es/components/controls/Button';
import { entityDetailEnhancer } from '@components/hoc/entityDetailEnhancer';

import * as T from '@modules/dictionary/_dictionaryTypes';
import defaultFields from '@modules/dictionary/DictionaryFields';
import { getDictionaryEntity } from '@modules/dictionary/_dictionaryActions';
import { dictionaryTemplates } from '@modules/dictionary/_dictionaryTemplates';

const enhance = compose(
  withRouter,
  withPropsOnChange(
    ['match'],
    ({
      match: {
        params: { dictionary }
      }
    }) => {
      const group = get(dictionaryTemplates, dictionary, {});
      return {
        dictionary,
        group,
        tabs: get(group, 'tabs'),
        fields: get(group, 'fields') || defaultFields,
        injectedGetEntityProps: { url: get(group, 'url', '') }
      };
    }
  ),
  entityDetailEnhancer<T.DictionaryEnhancerProps<T.Dictionary>, T.Dictionary>({
    getEntity: getDictionaryEntity,
    defaultEntity: {}
  }),
  withProps<{}, T.DictionaryProps>(({ entity }) => ({
    initialValues: {
      active: true,
      ...entity
    }
  })),
  reduxForm({
    form: 'dictionary-form'
  })
);

const FormView: React.SFC<any> = ({ fields, change, initialValues, context }) => {
  return (
    <React.Fragment>
      {isArray(fields) ? (
        <Col md={12}>
          {fields.map(Field => (
            <Field key={Field} change={change} initialValues={initialValues} context={context} />
          ))}
        </Col>
      ) : (
        keys(fields).map((section, index) => (
          <Col key={index} md={12}>
            <h3 style={{ marginTop: '15px' }}>{section}</h3>
            {fields[section].map(Field => (
              <Field key={Field} change={change} initialValues={initialValues} context={context} />
            ))}
          </Col>
        ))
      )}
    </React.Fragment>
  );
};

const View: React.SFC<T.Outter & T.DictionaryFormProps> = props => {
  return (
    <form onSubmit={props.handleSubmit}>
      <Grid fluid={true} style={{ maxHeight: '50vh', overflow: 'auto' }}>
        <Row>
          <Col xs={12}>
            <h2 style={{ marginTop: 0 }}>{get(props.group, 'formTitle', '')}</h2>
          </Col>
        </Row>
        <Row>
          {!!props.tabs ? (
            <Card>
              <Tabs>
                {keys(props.tabs).map((section, index) => (
                  <Tab key={index} label={section}>
                    <Col key={index} md={12}>
                      <FormView
                        fields={props.tabs && props.tabs[section]}
                        change={props.change}
                        initialValues={props.initialValues}
                        context={props.context}
                      />
                    </Col>
                  </Tab>
                ))}
              </Tabs>
            </Card>
          ) : (
            <FormView
              fields={props.fields}
              change={props.change}
              initialValues={props.initialValues}
              context={props.context}
            />
          )}
        </Row>
        <Row>
          <Col xs={12}>
            <Button type="submit" label="Uložit a zavřít" primary={true} style={{ margin: '24px', marginLeft: 0 }} />
            <Button label="Zrušit" style={{ margin: '24px 0' }} onClick={props.closeItem} />
          </Col>
        </Row>
      </Grid>
    </form>
  );
};

export const DictionaryForm = enhance(View);



// WEBPACK FOOTER //
// ./src/modules/dictionary/DictionaryForm.tsx